import React from "react";
import {Alert, Snackbar} from "@mui/material";
import {removeMessage} from "../../store/reducers/message";
import {useDispatch, useSelector} from "react-redux";
import {selectMessage} from "../../store/selectors";
import {AppDispatch} from "../../store";
import {Severity} from "../../store/state";

function AlertMessage() {
  const dispatch = useDispatch<AppDispatch>();
  const message = useSelector(selectMessage);
  const onClose = () => dispatch(removeMessage());
  return (
      <>
        {message &&
            <Snackbar open={!!message}
                      autoHideDuration={message.severity === Severity.SUCCESS ? 3000 : null}
                      onClose={onClose}
                      anchorOrigin={{vertical: "top", horizontal: "center"}}>
              <Alert severity={message.severity} onClose={onClose} variant="filled">
                {message.text}
              </Alert>
            </Snackbar>
        }
      </>
  );
}

export default AlertMessage;